export default barcode => {
  var regexp = /^[a-zA-Z]{2}[0-9]{14}$/;

  return regexp.test(barcode);
};
